import React, { useRef } from 'react';

import { useOutsideClick } from '../../../utils/custom-hooks';

import ModalWrapper from '../../base/modals/modal-wrapper';

import './styles/strategy-info-modal.scss';

const StrategyInfoModal = ({ strategy, setModalStrategy }) => {
  const modal = useRef(null);

  useOutsideClick(modal, () => setModalStrategy(null));

  const rate =
    strategy.status === 'upcoming'
      ? 'Details Coming Soon'
      : strategy.strategy_bid
      ? strategy.strategy_bid
      : strategy.commission_rate;
  const modalContent = (
    <div className="modal-content">
      <div className="full-info-content">
        <div className="full-info-item">
          <h2>Strategy Description</h2>
          <div>{strategy.strategy_description}</div>
        </div>
        <div className="half-info-item">
          <h2>Rate</h2>
          <div>{rate}</div>
        </div>
        <div className="half-info-item">
          <h2>Run Date</h2>
          <div>{strategy.strategy_date}</div>
        </div>
      </div>
    </div>
  );

  return strategy ? (
    <div className="strategy-info-modal">
      <ModalWrapper closeModal={() => setModalStrategy(null)}>
        <h3>{strategy.strategy_labels}</h3>
        <h1>{strategy.strategy_name}</h1>
        <div className="full-info-item">{strategy.active_since}</div>
        <span className="close-btn" onClick={() => setModalStrategy(null)}>
          X
        </span>
        {modalContent}
      </ModalWrapper>
    </div>
  ) : null;
};

export default StrategyInfoModal;
